<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.86122 19.9538L16.2521 12.5628C16.5616 12.253 16.5616 11.7516 16.2521 11.4419L8.86122 4.05086C8.55201 3.74189 8.04992 3.74189 7.7407 4.05086C7.43149 4.36062 7.43149 4.86279 7.7407 5.17176L14.5713 12.0019L7.7407 18.8329C7.43149 19.1419 7.43149 19.6441 7.7407 19.9538C8.04992 20.2628 8.55201 20.2628 8.86122 19.9538Z"
      fill="#CFD7DE"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardChevronRight'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
